export default function description() {
    return (
        <div className="card__description-basic">
            <div className="card__description">
                <div className="card__description-title">Загальна характеристика</div>
                <p className="card__description-text">
                    ТАУРУС — це гібрид, орієнтований на отримання високого врожаю за умови достатнього агрофону. Його головна перевага — поєднання інтенсивного росту та стабільності, що дозволяє максимально реалізувати потенціал на родючих ґрунтах.
                </p>
                <p className="card__description-text">
                    Гібрид добре реагує на покращені умови живлення та технології вирощування.
                </p>
                <ol className="card__description-list">
                    <p className="card__description-title">
                        Продуктивність і якість
                    </p>
                    <li className="card__description-numbering">Потенціал урожайності: до 5,2 т/га</li>
                    <li className="card__description-numbering">Олійність: 50–52%</li>
                    <li className="card__description-numbering">Стійкість до вовчка: A–E</li>
                    <p className="card__description-text">
                        Формує якісний урожай із хорошими показниками навіть у варіативних умовах.
                    </p>
                </ol>
                <div className="card__description-title">Морфологія та розвиток</div>
                <ol className="card__description-list">
                    <li className="card__description-numbering">Вегетаційний період: 109–113 днів</li>
                    <li className="card__description-numbering">Висота рослин: 170–180 см</li>
                    <p className="card__description-text">
                        Рослини мають потужний старт і рівномірний розвиток протягом вегетації.
                    </p>
                </ol>
                <div className="card__description-title">Адаптивність</div>
                <ol className="card__description-list">
                    <p className="card__description-text">
                        Рекомендований для вирощування у:
                    </p>
                    <li className="card__description-numbering">Поліссі</li>
                    <li className="card__description-numbering">Лісостепу</li>
                    <p className="card__description-text">
                        Найкраще проявляє себе на родючих ґрунтах із достатнім рівнем вологи.
                    </p>
                </ol>
                <div className="card__description-title">Ключові переваги</div>
                <ol className="card__description-list">
                    <li className="card__description-numbering">Інтенсивний стартовий ріст</li>
                    <li className="card__description-numbering">Високий потенціал урожайності на родючих ґрунтах</li>
                    <li className="card__description-numbering">Пластичність до строків посіву</li>
                    <li className="card__description-numbering">Стабільність при різних умовах вирощування</li>
                </ol>
                <div className="card__description-title">Практичне застосування</div>
                <ol className="card__description-list">
                    <p className="card__description-title">
                        ТАУРУС найкраще підходить для:
                    </p>
                    <li className="card__description-numbering">господарств із середнім та високим рівнем технологій</li>
                    <li className="card__description-numbering">родючих полів</li>
                    <li className="card__description-numbering">інтенсивного землеробства</li>
                    <p className="card__description-text">
                        Рекомендується застосування гербіцидів системи Clearfield®.
                    </p>
                </ol>
                <div className="aside__title">Агрохімічні характеристики</div>
                <div className="aside__content">
                    <div className="aside-char--basic">
                        <div className="aside-char__head">Енергiя початкового росту</div>
                        <div className="aside-char__char">
                            <div className="aside-char__items aside-char__items--9">
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                            <div className="aside-char__count">9</div>
                        </div>
                    </div>
                    <div className="aside-char--basic">
                        <div className="aside-char__head">Посухостiйкiсть</div>
                        <div className="aside-char__char">
                            <div className="aside-char__items aside-char__items--9">
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                            <div className="aside-char__count">9</div>
                        </div>
                    </div>
                    <div className="aside-char--basic">
                        <div className="aside-char__head">Стiйкiсть до вилягання</div>
                        <div className="aside-char__char">
                            <div className="aside-char__items aside-char__items--8">
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                            <div className="aside-char__count">8</div>
                        </div>
                    </div>
                </div>
                <p className="card__description-text">
                    ТАУРУС — це гібрид для тих, хто хоче максимально реалізувати потенціал поля і отримати високий результат.
                </p>
            </div>
            <div className="card__description-preference">
                <div className="aside__title--new">Головні переваги</div>
                <div className="asede__head">
                    <div className="aside__block">Високі темпи росту на перших етапах розвитку</div>
                    <div className="aside__block">Найкращу врожайність забезпечує на родючих ґрунтах</div>
                    <div className="aside__block">Пластичний до термінів посіву</div>
                </div>
            </div>
        </div>
    );
}
